/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/prototype/revolve；
 * 2. 负责定义旋转族特征的统一原型对象；
 * 3. 旋转凸台与旋转切除共享该骨架，子类只表达语义标签。
 */

import type { FeatureReferenceBinding } from '../../binding/FeatureReferenceBinding';
import { RevolveFeatureDefinitionModel } from '../../definition/revolve/RevolveFeatureDefinition';
import { FeaturePrototype } from '../FeaturePrototype';

/**
 * 旋转族特征原型。
 */
export class RevolveFeaturePrototype extends FeaturePrototype<RevolveFeatureDefinitionModel> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        featureId: string;
        definition: RevolveFeatureDefinitionModel;
        bindings: FeatureReferenceBinding[];
        sourceSketchId?: string | null;
    }) {
        super(input);
    }
}
